import React, { useEffect, useState } from "react";
import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
import Image from "next/image";
import "swiper/css/effect-fade";
import { AnimatePresence, m } from "framer-motion";
import Link from "next/link";
export default function Banner({ featuredProjects }) {
  return (
    <div className="projectCarousel w-full">
      <Carousel
        slidesPerView={1}
        spaceBetween={0}
        loop={true}
        total={5}
        navigation={false}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        effect={"fade"}
        showNavAbove={false}
        centeredSlides={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        }}
      >
        {featuredProjects.map((row, key) => (
          <SwiperSlide key={"projectBanner" + key}>
            {({ isActive }) => <Slide data={row} isActive={isActive} />}
          </SwiperSlide>
        ))}
      </Carousel>
    </div>
  );
}
const Slide = ({ data, isActive }) => {
  const [hover, setHover] = useState(false);
  useEffect(() => {
    setHover(false);
  }, []);
  return (
    <Link
      href={`/projects/${data?.slug}`}
      className="flex flex-col w-full group"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="w-full lg:h-[45vw] md:h-[693px] h-[650px] relative">
        <Image
          src={data?.banner?.data?.attributes?.url ?? "/images/placeholder.svg"}
          alt={
            data?.banner?.data?.attributes?.alternativeText ??
            data?.title ??
            "project image"
          }
          sizes="(max-width: 479px) 500px, 1920px"
          fill
          priority={isActive ? true : false}
          className="w-full h-full object-cover object-center md:block hidden"
        />
        <Image
          src={
            data?.mobileBanner?.data?.attributes?.url ??
            data?.banner?.data?.attributes?.url ??
            "/images/placeholder.svg"
          }
          alt={
            data?.mobileBanner?.data?.attributes?.alternativeText ??
            data?.banner?.data?.attributes?.alternativeText ??
            data?.title ??
            "project image"
          }
          sizes="(max-width: 479px) 500px, 1920px"
          fill
          priority={isActive ? true : false}
          className="w-full h-full object-cover object-center md:hidden block"
        />
        <div className="absolute top-0 left-0 md:px-8 px-4 md:pb-8 pb-16 w-full h-full bg-black/20 group-hover:bg-black/60 transition-all duration-500 ease flex flex-col justify-end">
          <div className="flex flex-col items-center w-full justify-center">
            {isActive && (
              <m.h1
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 100 }}
                transition={{ duration: 0.5 }}
                exit={{ y: 50, opacity: 0 }}
                className="text-white uppercase font-light font-havletica text-center text-[25px]"
              >
                {data?.title}
              </m.h1>
            )}
            {isActive && (
              <m.div
                initial={{ y: 20, height: 0, opacity: 0 }}
                animate={{
                  y: 0,
                  height: hover ? 40 : 0,
                  opacity: hover ? 100 : 0,
                }}
                transition={{ duration: 0.5 }}
                exit={{ y: 20, height: 0, opacity: 0 }}
                className="grid grid-cols-3 auto-rows-auto items-center justify-center lg:gap-[300px] md:gap-[100px] gap-8   w-fit overflow-hidden mt-4"
              >
                <p className="text-[#EDEDED] uppercase font-light text-center">
                  {data?.projectType}
                </p>
                <p className="text-[#EDEDED] uppercase font-light text-center">
                  {data?.size}
                </p>
                <p className="text-[#EDEDED] uppercase font-light text-center">
                  {data?.location}
                </p>
              </m.div>
            )}
            <AnimatePresence>
              {isActive && (
                <m.div
                  initial={{ y: 50, opacity: 0 }}
                  animate={{ y: 0, opacity: 100 }}
                  transition={{ duration: 0.5 }}
                  exit={{ y: 50, opacity: 0 }}
                  className="flex flex-row items-center justify-between w-full md:mt-10 mt-6 md:px-12"
                >
                  <p className="text-sm text-[#F6F5F1] font-normal">
                    {data?.site}
                  </p>
                  <p className="text-sm text-[#F6F5F1] font-normal">
                    {data?.projectType}
                  </p>
                </m.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </Link>
  );
};
